import React, { Component } from "react";
import Overlay55 from "./overlay-55.png";
import Overlay65 from "./overlay-65.png";
import Overlay75 from "./overlay-75.png";

class DBIndicator extends Component {
  determineBenefit = (benefit) => {
    if (benefit === "Seller's") {
      return "— A Seller's Advantage";
    } else if (benefit === "buyer's") {
      return "— A Buyers Advantage";
    }
  };
  render() {
    let { statement, header, logic, index, benefit, mlsAreaID } = this.props;

    let shadowToUse;
    if (+index === 1) {
      shadowToUse = Overlay55;
    } else if (+index === 2) {
      shadowToUse = Overlay65;
    } else if (+index === 3) {
      shadowToUse = Overlay65;
    } else if (+index === 4) {
      shadowToUse = Overlay75;
    }
    let logicStart = logic.slice();
    // console.log("logicStart", logicStart);
    let benefitSentence = logic.slice();
    let indicatorExplanationStyles = "";
    let indicatorAdvantageStyles;

    if (benefit) {
      benefitSentence += `<p class="indicator-benefit">${this.determineBenefit(
        benefit
      )}</p>`;
    }

    let headerStyles;
    if (header && header.length >= 33) {
      headerStyles = "db-header-more-width";
    } else if (header && header.length >= 39) {
      headerStyles = "db-indicator-medium-header";
    }

    if (benefitSentence && benefitSentence.length < 60) {
      indicatorAdvantageStyles = "indicator-advantage-left";
    }
    let dbBoxStyles;

    return (
      <div className="db-indicator">
        <p className={`indicator-header-num header-num-${index}`}>{index}</p>

        <div className="db-floating-box">
          <div className="db-divider" />
          <div
            className={`db-box-inner-container box-inner-${
              index & 1 ? "odd" : "even"
            } ${dbBoxStyles}`}
          >
            <div className="indicator-header">
              <p className={`indicator-header-category ${headerStyles}`}>
                {header}
              </p>
            </div>

            <div
              className={`indicator-explanation ${indicatorExplanationStyles}`}
              dangerouslySetInnerHTML={{ __html: statement }}
            ></div>
            <div className="indicator-advantage-and-benefit-container">
              <div
                className={`indicator-advantage ${indicatorAdvantageStyles}`}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: benefitSentence }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DBIndicator;
